import { toAbsoluteUrl } from '../../../_metronic/helpers'

const Search = ({filters, onChange, loadData, downloadExcel}) => {
  return (
    <div className="row">
      <div className="card col-md-12">
        <div className="card-body">
          {/* Proceso de Liquidación
            <span className='indicator-progress' style={{display: 'block'}}>
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span> */}
          <div className="row">
            <div className="col-xxl-5">
              <label className="fs-4 fw-bold">Seleccione tipo de pago*</label>
              <select className="form-select form-select-white" aria-label="..." name="tipopago" value={filters.tipopago} onChange={onChange}>
                <option value="-1" disabled>Seleccione...</option>
                <option value="0">Todos</option>
                <option value="1">HMQ</option>
                <option value="2">Consulta</option>
              </select>
            </div>
            <div className="col-xxl-4">
              <label className="fs-4 fw-bold">Seleccione estado*</label>
              <select className="form-select form-select-white" aria-label="..." name="estado" value={filters.estado} onChange={onChange}>
                <option value="-1" disabled>Seleccione...</option>
                <option value="0">Todos</option>
                <option value="1">NO RETIRADO</option>
                <option value="2">TRANSFERIDO</option>
              </select>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-xxl-5">
              <label className="fs-4 fw-bold">Fecha Desde*</label>
              <input
                name="start_date"
                className="form-control"
                type="month"
                value={filters.start_date}
                onChange={onChange}
              />
            </div>
            <div className="col-xxl-4">
              <label className="fs-4 fw-bold">Fecha hasta*</label>
              <input
                name="end_date"
                className="form-control"
                type="month"
                value={filters.end_date}
                onChange={onChange}
              />
            </div>
            <div className="col-xxl-3 col-lg-12">
              <div className='mt-7 text-center'>
                <button type='button' className='btn btn-primaryamsm' style={{ marginRight: '10px' }} onClick={() => loadData()}>
                  Buscar
                </button>
                <button className="icon-button btn btn-outline btn-outline-primaryamsm btn-active-light-primary" onClick={() => downloadExcel()}>
                  <div className="icon-container">
                    <span>Excel</span>
                    <img src={toAbsoluteUrl('/media/icons/732220.png')} alt="Descarga Excel" />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Search;
